export default __webpack_public_path__ + "static/media/product-dna.d4eca1af.svg";